<template>
  <div></div>
</template>

<script>
import { loginFB } from "@/service/api";
import getSignedObject from "@/service/sign";
import { getFromStorage } from "@/service/utils";

export default {
  data() {
    return {
      user: {},
      token: ""
    };
  },
  methods: {
    getUser() {
      const self = this;
      if (window.FB && this.token) {
        // FB SDK
        window.FB.api(`/me?access_token=${this.token}`, res => {
          self.user = res;
          self.loginUser(res);
        });
      }
    },
    loginUser() {
      loginFB(
        getSignedObject({
          fb_user_id: this.user.id,
          access_token: this.token
        })
      ).then(res => {
        if (res.user_id) {
          this.$store.commit("SET_USER", res);
          window.$event("Successfully_Login", {});
        }
        const page = getFromStorage("LOGIN_FROM") || {};
        const { name, query } = page;
        const toName = name === "content" ? "content" : "me";
        const pageQuery = query || {};
        // now for simplify just navigate user to these two pages
        this.$router.replace({ name: toName, query: pageQuery });
      });
    }
  },
  mounted() {
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get("access_token");
    this.token = token;
    this.getUser();
  }
};
</script>

<style lang="scss"></style>
